import Image from 'next/image';
import React, { useState } from 'react';

const CodeBlockWithCopyButton = ({ code }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(code);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div
      className={`code-block ${isHovered ? 'hovered' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleCopyClick}
    >
      <pre>{code}</pre>
      <button onClick={handleCopyClick} className={isCopied ? 'copied' : ''}>
        {!isCopied && <Image src="/icons/copy.svg" width={15} height={15} />}
        {isCopied ? ' Copied!' : ' Copy'}
      </button>
      <style jsx>{`
        .code-block {
          position: relative;
          width: 100%;
          cursor: pointer;
        }
        pre {
          background-color: #242424;
          padding: 10px;
          border-radius: 5px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          transition: background-color 0.3s ease;
        }
        button {
          position: absolute;
          top: 5px;
          right: 5px;
          padding: 5px 10px;
          border: none;
          background-color: #007bff;
          color: #fff;
          border-radius: 5px;
          cursor: pointer;
          opacity: 0;
          transition: opacity 0.3s ease;
          display: flex;
          justify-content: center;
          align-content: center;
        }
        .code-block.hovered button {
          opacity: 1;
        }
        .copied {
          background-color: green !important;
        }
      `}</style>
    </div>
  );
};

export default CodeBlockWithCopyButton;
